import { useCallback } from "react";
import { MapContainer, TileLayer } from "react-leaflet";
import { GeoJsonDropzone } from "./GeoJsonDropzone";

export function MapDrawOptions({
  handleDrawingMode,
  handleGeoJsonLoaded,
  t,
  setIsGeofenceLoadedByGeoJson,
  handleEnableAreaSelector,
  showSelectSavedAreaButton = true,
  isDropZoneVisible,
  setIsDropZoneVisible,
}: {
  handleDrawingMode?: () => void;
  handleGeoJsonLoaded?: (geojson: any) => void;
  t: (key: string) => string;
  setIsGeofenceLoadedByGeoJson?: (value: boolean) => void;
  handleEnableAreaSelector?: (value: boolean) => void;
  showSelectSavedAreaButton?: boolean;
  isDropZoneVisible?: boolean;
  setIsDropZoneVisible?: (value: boolean) => void;
}) {
  const handleGeoJsonMode = () => {
    setIsDropZoneVisible?.(true);
  };

  const _handleGeoJsonLoaded = useCallback(
    (geojson: any) => {
      handleGeoJsonLoaded?.(geojson);
      setIsDropZoneVisible?.(false);
    },
    [handleGeoJsonLoaded]
  );

  return (
    <div
      style={{
        position: "relative",
        height: "256px",
        width: "100%",
        borderRadius: "8px",
        overflow: "hidden",
      }}
    >
      <MapContainer
        center={[0, 0]}
        zoom={2}
        style={{
          height: "100%",
          width: "100%",
          filter: "grayscale(80%) brightness(0.7)",
          borderRadius: "8px",
        }}
        scrollWheelZoom={false}
        dragging={false}
        doubleClickZoom={false}
        zoomControl={false}
        touchZoom={false}
        boxZoom={false}
        keyboard={false}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="&copy; OpenStreetMap contributors"
        />
      </MapContainer>

      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: "flex",
          flexDirection: "row",
          gap: "10px",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgba(0, 0, 0, 0.3)",
          color: "white",
          textAlign: "center",
          padding: "20px",
        }}
      >
        {isDropZoneVisible ? (
          <GeoJsonDropzone onFileLoad={_handleGeoJsonLoaded} t={t} />
        ) : (
          <>
            <button
              style={{
                padding: "10px 20px",
                backgroundColor: "#FFF",
                color: "#086AA9",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "bold",
              }}
              onClick={() => {
                handleDrawingMode?.();
                setIsGeofenceLoadedByGeoJson?.(false);
              }}
            >
              {t("drawArea")}
            </button>
            {showSelectSavedAreaButton && (
              <button
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#FFF",
                  color: "#086AA9",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "bold",
                }}
                onClick={() => {
                  handleEnableAreaSelector?.(true);
                }}
              >
                {t("selectSavedArea")}
              </button>
            )}
            <button
              style={{
                padding: "10px 20px",
                backgroundColor: "#FFF",
                color: "#086AA9",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "bold",
              }}
              onClick={handleGeoJsonMode}
            >
              {t("importGeojson")}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
